import type { Me } from '@shared/api/types'

/**
 * A banned owner may reauthenticate only to inspect the active ban, appeal it,
 * read that appeal and sign out. `/me` contains only currently active sanctions,
 * so this predicate also acts as the client-side proof for the restricted shell.
 */
export function isBannedAppealSession(me: Me | null | undefined): boolean {
  return (
    me?.user.status === 'suspended' &&
    me.sanctions.some((sanction) => sanction.type === 'banned' && sanction.appealable)
  )
}
